import React from "react";
import TransporterTable from "./TransporterTable";

const TransporterViewContent = () => {
  return (
    <div className="">
      <TransporterTable />
    </div>
  );
};

export default TransporterViewContent;
